import React from 'react';
import './About1.css';
import { useTranslation } from 'react-i18next';

const content = {
  swe: {
    heading: 'Ett samarbete som börjar med din idé',
    introduction: 'Varje projekt är unikt. Vi hjälper dig att göra behov och idéer till en tydlig väg framåt.',
    items: [
      ['Vi lyssnar först', 'Berätta vad du vill åstadkomma. Vi går igenom funktion, användning och förutsättningar tillsammans.'],
      ['En lösning för dina behov', 'Vi anpassar arbetets omfattning efter projektet, oavsett om du behöver digital utveckling, elektronik, design eller 3D-utskrift.'],
      ['Tydliga nästa steg', 'Vi diskuterar krav, leverans och tidsplan så att du vet vad förslaget omfattar innan arbetet börjar.'],
      ['Nära dialog', 'Dina synpunkter hjälper oss att utveckla lösningen. Vi håller kontakten genom projektets olika steg.'],
    ],
  },
  en: {
    heading: 'A collaboration that starts with your idea',
    introduction: 'Every project is different. We help you turn needs and ideas into a clear way forward.',
    items: [
      ['We listen first', 'Tell us what you want to achieve. We explore the function, intended use and requirements together.'],
      ['A solution for your needs', 'We shape the scope around your project, whether you need digital development, electronics, design or 3D printing.'],
      ['Clear next steps', 'We discuss requirements, delivery and timing so you understand the proposal before the work begins.'],
      ['An ongoing conversation', 'Your feedback helps us develop the solution. We stay in touch throughout the project.'],
    ],
  },
};

function About1() {
  const { i18n } = useTranslation();
  const copy = content[i18n.language?.startsWith('en') ? 'en' : 'swe'];

  return (
    <section className="about1-us" aria-labelledby="working-together-heading">
      <div className="about1-heading">
        <h2 id="working-together-heading">{copy.heading}</h2>
        <p>{copy.introduction}</p>
      </div>
      <div className="about1-grid">
        {copy.items.map(([title, description], index) => (
          <article className="about1-item" key={title}>
            <span className="about1-number" aria-hidden="true">0{index + 1}</span>
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default About1;
